import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { supabase } from "../supabaseClient";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setError(error.message);
      return;
    }

    await supabase.auth.signOut();
    setMessage("Password updated successfully! Redirecting to login...");

    setTimeout(() => {
      window.location.href = "/";
    }, 2000);
  };

  return (
    <div className="min-h-screen bg-bg text-text-primary flex items-center justify-center p-6">
      <div className="w-full max-w-lg bg-white border border-border p-10 rounded-2xl shadow-sm">

        <h1 className="text-3xl font-bold mb-6 text-text-primary">Reset Your Password</h1>
        <p className="text-text-secondary mb-8">Enter your new password below.</p>

        <form onSubmit={handleReset} className="space-y-5">
          <div>
            <label className="block text-text-primary mb-2 text-sm">New Password</label>
            <input
              type="password"
              className="w-full px-4 py-3 rounded-md bg-bg-soft border border-border text-text-primary placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-accent transition"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <p className="text-red-500 text-sm">{error}</p>}
          {message && <p className="text-green-600 text-sm">{message}</p>}

          {message ? (
            <button
              type="button"
              onClick={() => navigate("/login")}
              className="w-full bg-primary text-white font-bold py-3 rounded-md hover:bg-primary-soft transition"
            >
              Back to Login
            </button>
          ) : (
            <button
              type="submit"
              className="w-full bg-primary text-white font-bold py-3 rounded-md hover:bg-primary-soft transition"
            >
              Update Password
            </button>
          )}
        </form>

      </div>
    </div>
  );
}